// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderContainer":"PageLoader__pageLoaderContainer--Izi","pageLoaderText":"PageLoader__pageLoaderText--2eX"};